@if (!router.url.includes('editor-live')) {
  <rbb-navbar [config]="navbarConfig" [navigationTemplate]="navigationTemplate"/>
}
<ng-template #navigationTemplate>

  <li class="nav-item" routerLinkActive="active">
    <a class="nav-link" routerLink="/list">
      <i class="fas fa-book"></i> Alle Formulare
    </a>
  </li>
  @if (!accessService.usernameContext || accessService.usernameContextToApprove) {
    <li class="nav-item dropdown" routerLinkActive="active">
      <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" id="navbarDropdownDoku">
        <i class="fas fa-file-alt"></i> Anträge
        @if (!accessService.usernameContext ? (approveCounter + progressCounter) : approveCounter) {
          <span class="badge rounded-pill bg-primary fw-bold">{{!accessService.usernameContext ? (approveCounter + progressCounter) : approveCounter}}</span>
        }
      </a>
      <div aria-labelledby="navbarDropdownDoku" class="dropdown-menu dropdown-menu-end">
        <a class="dropdown-item" routerLink="/my-forms" routerLinkActive="active">
          <i class="fas fa-file-alt"></i> Meine Anträge</a>
        <a class="dropdown-item" routerLink="/review" routerLinkActive="active">
          <i class="fas fa-file-alt"></i> Zu prüfende Anträge
          @if (approveCounter) {
            <span class="badge rounded-pill bg-primary fw-bold">{{approveCounter}}</span>
          }
        </a>
        @if (employee && employee.operator && !accessService.usernameContext) {
          <a class="dropdown-item" routerLink="/processing" routerLinkActive="active">
            <i class="fas fa-file-alt"></i> Zu bearbeitende Anträge
            @if (progressCounter) {
              <span class="badge rounded-pill bg-primary fw-bold">{{progressCounter}}</span>
            }
          </a>
        }
      </div>
    </li>
  }
  @if (accessService.usernameContext && !accessService.usernameContextToApprove) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" routerLink="/my-forms">
        <i class="fas fa-file-alt"></i> Anträge
      </a>
    </li>
  }
  @if (!accessService.usernameContext) {
    <li class="nav-item dropdown" routerLinkActive="active">
      <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" id="navbarDropdownEditor">
        <i class="fas fa-edit"></i> Editor
      </a>
      @if (employee && (employee.creator || employee.owner)) {
        <div aria-labelledby="navbarDropdownEditor" class="dropdown-menu dropdown-menu-end">
          <a class="dropdown-item" routerLink="/editor" routerLinkActive="active">
            <i class="fas fa-edit"></i> Formulare
          </a>
          @if (employee.creator) {
            <a class="dropdown-item" routerLink="/form-groups" routerLinkActive="active">
              <i class="fas fa-copy"></i> Gruppen
            </a>
          }
        </div>
      }
    </li>
  }
  <li class="nav-item" routerLinkActive="active">
    <a class="nav-link" routerLink="/my-data">
      <i class="fas fa-user"></i> Meine Daten
    </a>
  </li>
  @if (employee && employee.dataProtectionOfficer && !accessService.usernameContext) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" routerLink="/data-protection-officer">
        <i class="fas fa-user-shield"></i> DSB
      </a>
    </li>
  }
  @if (receivedAccess?.length) {
    <li class="nav-item dropdown" routerLinkActive="active">
      <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" id="navbarDropdownAccess">
        <i class="fas fa-key"></i> Zugriff
      </a>
      <div aria-labelledby="navbarDropdownAccess" class="dropdown-menu dropdown-menu-end">
        @for (access of receivedAccess; track access) {
          <a class="dropdown-item pointer" [class.active]="access.username === accessService.usernameContext" (click)="setAccess(access)" (keydown.enter)="setAccess(access)" (keydown.space)="setAccess(access)" tabindex="0">
            <i class="fas fa-user"></i> {{access.firstName}} {{access.lastName}}
          </a>
        }
        @if (accessService.usernameContext) {
          <a class="dropdown-item pointer" (click)="setAccess(undefined)" (keydown.enter)="setAccess(undefined)" (keydown.space)="setAccess(undefined)" tabindex="0">
            <i class="fas fa-times"></i> Zugriff beenden
          </a>
        }
      </div>
    </li>
  }
  <li class="nav-item" routerLinkActive="active">
    <a class="nav-link" routerLink="/faq">
      <i class="fas fa-question"></i><i class="fa-solid fa-exclamation"></i> FAQ
    </a>
  </li>
  @if (employee?.admin && !accessService.usernameContext) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" routerLink="/admin">
        <i class="fa-solid fa-screwdriver-wrench"></i> Admin
      </a>
    </li>
  }
</ng-template>

@if (accessService.usernameContext) {
  <div class="nav-secondary-bar">
    <nav class="nav bg-primary text-light fw-bold ps-3 py-2">
      <div>
        <span class="align-middle">Sie sehen aktuell die Anträge von {{this.accessService.usernameContextFirstName}} {{this.accessService.usernameContextLastName}}.</span>
        <button class="btn btn-sm btn-light ms-3" (click)="setAccess(undefined)">Zugriff beenden.</button>
      </div>
    </nav>
  </div>
}

@if (employee?.notSapData && (!employee?.orgUnit || !employee?.costCentre)) {
  <div class="nav-secondary-bar">
    <nav class="nav nav-underline bg-warning fw-bold ps-3 py-2">
      <div>
        <span class="align-middle">Ihre Daten sind nicht vollständig und daher können Sie rbb Forms noch nicht nutzen. Bitte wählen Sie unter "Meine Daten" Ihre Organisationseinheit und Ihre Kostenstelle aus.</span>
      </div>
    </nav>
  </div>
}
